/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2024-01-09 09:09:32
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\besSer\WMmanagement\inventory.js
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/sign/goodService/repertoryManage/queryPage'
export const saveOrUpdate = '/icps/system/sign/goodService/repertoryManage/saveOneResord'
/**获取周材名列表*/
export function queryNameList(params) {
  return request({
    url: '/icps/system/sign/goodService/repertoryManage/queryNameList',
    method: 'get',
    params
  })
}
/**删除*/
export function deleteMateria(params) {
  return request({
    url: '/icps/system/sign/goodService/repertoryManage/deleteMateria',
    method: 'get',
    params
  })
}
/**:获取规格和类型列表*/
export function querySpecification(data) {
  return request({
    url: '/icps/system/sign/goodService/repertoryManage/querySpecification',
    method: 'post',
    data
  })
}
/**:添加盘点记录*/
export function saveOneResord(data) {
  return request({
    url: '/icps/system/sign/goodService/materialsCheck/saveOneResord',
    method: 'post',
    data
  })
}
/**:获取盘点记录*/
export function queryList(data) {
  return request({
    url: '/icps/system/sign/goodService/materialsCheck/queryList',
    method: 'post',
    data
  })
}
/**:周材调级*/
export function adjustWageScale(data) {
  return request({
    url: '/icps/system/sign/goodService/repertoryManage/adjustWageScale',
    method: 'post',
    data
  })
}
/**:入库*/
export function inWarehouse(data) {
  return request({
    url: '/icps/system/sign/goodService/repertoryManage/inWarehouse',
    method: 'post',
    data
  })
}
/**: 库存明细*/
export function queryDetailPage(data) {
  return request({
    url: '/icps/system/sign/goodService/repertoryManage/queryDetailPage',
    method: 'post',
    data
  })
}
/**: 库存盘点*/
export function inventoryStock(data) {
  return request({
    url: '/icps/system/sign/goodService/repertoryManage/inventoryStock',
    method: 'post',
    data
  })
}
/**: 盘点记录*/
export function queryInventoryPage(data) {
  return request({
    url: '/icps/system/sign/goodService/repertoryManage/queryInventoryPage',
    method: 'post',
    data
  })
}